import React, { useState, useCallback } from "react";
import quizAPI from "../../libs/api/quiz";
import { TimerCountDown } from "../../components/timer/timercountdown";
import {
  exerciseType,AccountType
} from "../../components/constants/constants";
import { Row } from "reactstrap";
import { getQuizId } from "../../App";

export const TempHeader = ({
  isReview,
  data,
  isStopTimer,
  setIsStopTimer,
  timer,
  edit_template,
}) => {
  const [isSaved, setisSaved] = useState(data?.is_saved_exercise ? true : false);
  const [saveOnTimeOver, SetSaveOnTimeOver] = useState(false);
  const exerciseSave = useCallback(
    () => {
      quizAPI
      .post({ id: getQuizId(), data: {exercise_saved: true} })
      .then((res) => res.json())
      .then((json) => {
        if (json["success"]){
          if (json.message === 'exercise added') {
            setisSaved(true);
          }
          else{
            setisSaved(false);
          }
        }
      });
    },
    []
  );
  let class_name = "exercise-bg-grammer";
  if (data.task_type === exerciseType.GRAMMAR_TASK) {
    class_name = "exercise-bg-grammer";
  } else if (data.task_type === exerciseType.WRITING_TASK) {
    class_name = "exercise-bg-writing";
  } else if (data.task_type === exerciseType.VOCABULARY_TASK) {
    class_name = "exercise-bg-vocab";
  } else if (data.task_type === exerciseType.PRONUNCIATION_TASK || data.task_type === exerciseType.SPEAKING_TASK) {
    class_name = "exercise-bg-pronunciation";
  } else if (data.task_type === exerciseType.READING_TASK) {
    class_name = "exercise-bg-reading";
  } else if (data.task_type === exerciseType.LISTENING_TASK) {
    class_name = "exercise-bg-listening";
  }
  return (
    <Row className="px-4 pt-3 g-0">
        <div className="col-7">
            <div class="col-7 d-flex">
                <div class={`col-2 ${class_name} quiz-icon rounded-5 d-flex justify-content-center align-items-center`}>
                    {data && data?.task_exercise_types && data?.task_exercise_types[0]?.exercise_icon ? (
                        <img src={data?.task_exercise_types[0].exercise_icon} alt="...question icon" />
                    ): data && data.question_type_icon && (
                      <img src={data.question_type_icon} alt="...question icon" />
                    )}
                </div>
                {data.user_type === AccountType.STUDENT ? (
                  <div class="col-12 d-flex ps-3">
                      <div class="col-5">
                          <label class="text-lgrey">Skill</label>
                          <div><b>{data.task_type.split(" ")[0]}</b></div>
                      </div>
                      <div class="col-3 qlg-display">
                          <label class="text-lgrey">Level</label>
                          {data?.task_levels && data.task_levels?.[0]?.value ? (
                              <div class="d-flex text-nowrap">
                              {data.task_levels.map((level, index) => (
                                  <b>{index > 0 ? (<span>, </span>):null}{level?.value}</b>
                              ))}
                              </div>
                              ): (
                                  <div>
                                      <b>-</b>
                                  </div>
                              )}
                      </div>
                      <div class="col-5 px-1 qlg-display">
                          <label class="text-lgrey">Time allowed</label>
                          <div>
                              <b >
                              {data && data?.assignment_allowed_time ? (
                              <span>{data.assignment_allowed_time} minutes </span> 
                              ):(
                                  <span>-</span>
                              )}
                              </b>
                          </div>
                      </div>
                  </div>
                ): (
                  <div class="col-12 d-flex ps-3">
                    <div class="col-5">
                        <label class="text-lgrey">Skill</label>
                        <div><b>{data.task_type.split(" ")[0]}</b></div>
                    </div>
                    <div class="col-5 px-1">
                        <label class="text-lgrey">Type</label>
                        <div>
                            <b >
                            {data && data?.task_exercise_types && data?.task_exercise_types?.[0]?.value ? (
                            <span class="exercise-text lh-0">{data?.task_exercise_types?.[0]?.value} </span> 
                            ): data && data?.question_type ? (
                              <span class="exercise-text lh-0">{data?.question_type} </span> 
                            ):(
                                <span>-</span>
                            )}
                            </b>
                        </div>
                    </div>
                    <div class="col-3">
                        <label class="text-lgrey">Level</label>
                        {data?.task_levels && data.task_levels?.[0]?.value ? (
                            <div class="d-flex text-nowrap">
                            {data.task_levels.map((level, index) => (
                                <b>{index > 0 ? (<span>, </span>):null}{level?.value}</b>
                            ))}
                            </div>
                            ) : data?.task_level ?(
                                <div>
                                    <b>{data?.task_level}</b>
                                </div>
                            ):(
                              <div>
                                  <b>-</b>
                              </div>
                          )}
                    </div>
                  </div>
                )}
            </div>
        </div>
        <div className="col-5 align-self-center">
        {data.user_type === AccountType.STUDENT ? (
          <div className="col-12 d-flex justify-content-end">
            <div>
              <label class="text-lgrey">Timer</label>
              <div>
                <b>
                  {data && timer && (
                    <TimerCountDown
                        isStopTimer={
                          data.user_type !== AccountType.STUDENT || isReview
                            ? true
                            : isStopTimer
                        }
                        data={data}
                        localSpentTime={timer}
                        // setShowTimeWarning={setShowTimeWarning}
                        totalTimeInSeconds={data?.assignment_allowed_time}
                        onStop={(props) => {
                          if(!saveOnTimeOver)
                          {
                            alert("Times up");
                            setIsStopTimer(false);
                            SetSaveOnTimeOver(true);
                            // creatQuizDataAndSubmit();
                          }
                          }}
                      />
                  )}
                </b>
              </div>
            </div>
          </div>
      ): (
          <div className="col-12 d-flex justify-content-end">
            <span class="fs-14">
              {isSaved ? (
                <button onClick={exerciseSave} className="bg-white p-0 border-0" type="button">
                  <span class="text-dark">
                    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.00701 15.6467L12.8287 22.9944C12.9763 23.1331 13.0501 23.2024 13.1258 23.2459C13.3574 23.3793 13.6426 23.3793 13.8742 23.2459C13.9499 23.2024 14.0237 23.1331 14.1713 22.9944L21.993 15.6467C24.1937 13.5794 24.4609 10.1774 22.61 7.79183L22.262 7.34326C20.0478 4.4894 15.6033 4.96802 14.0475 8.22786C13.8277 8.68833 13.1723 8.68833 12.9525 8.22786C11.3967 4.96802 6.95219 4.4894 4.73799 7.34326L4.38996 7.79183C2.53907 10.1774 2.80631 13.5794 5.00701 15.6467Z" fill="#E52521" stroke="#E52521" stroke-width="3"/>
                      <path d="M25.502 18.75C25.502 21.6495 23.1514 24 20.252 24C17.3525 24 15.002 21.6495 15.002 18.75C15.002 15.8505 17.3525 13.5 20.252 13.5C23.1514 13.5 25.502 15.8505 25.502 18.75Z" fill="white"/>
                      <path d="M20.252 21.375L20.252 16.125M22.877 18.75L17.627 18.75M25.502 18.75C25.502 21.6495 23.1514 24 20.252 24C17.3525 24 15.002 21.6495 15.002 18.75C15.002 15.8505 17.3525 13.5 20.252 13.5C23.1514 13.5 25.502 15.8505 25.502 18.75Z" stroke="black" stroke-width="0.75" stroke-linecap="square"/>
                    </svg>  
                  </span>
                </button>
              ):(
                <button onClick={exerciseSave} className="bg-white p-0 border-0"  type="button">
                  <span class="text-dark">
                    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.00701 15.6467L12.8287 22.9944C12.9763 23.1331 13.0501 23.2024 13.1258 23.2459C13.3574 23.3793 13.6426 23.3793 13.8742 23.2459C13.9499 23.2024 14.0237 23.1331 14.1713 22.9944L21.993 15.6467C24.1937 13.5794 24.4609 10.1774 22.61 7.79183L22.262 7.34326C20.0478 4.4894 15.6033 4.96802 14.0475 8.22786C13.8277 8.68833 13.1723 8.68833 12.9525 8.22786C11.3967 4.96802 6.95219 4.4894 4.73799 7.34326L4.38996 7.79183C2.53907 10.1774 2.80631 13.5794 5.00701 15.6467Z" fill="white" stroke="#E52521" stroke-width="3"/>
                      <path d="M25.502 18.75C25.502 21.6495 23.1514 24 20.252 24C17.3525 24 15.002 21.6495 15.002 18.75C15.002 15.8505 17.3525 13.5 20.252 13.5C23.1514 13.5 25.502 15.8505 25.502 18.75Z" fill="white"/>
                      <path d="M20.252 21.375L20.252 16.125M22.877 18.75L17.627 18.75M25.502 18.75C25.502 21.6495 23.1514 24 20.252 24C17.3525 24 15.002 21.6495 15.002 18.75C15.002 15.8505 17.3525 13.5 20.252 13.5C23.1514 13.5 25.502 15.8505 25.502 18.75Z" stroke="black" stroke-width="0.75" stroke-linecap="square"/>
                    </svg>                                
                  </span>
                </button>
              )}
            </span>
          </div>
        )}
        </div>
        <p className="quiz-bottom-border pt-3"></p>
    </Row>
  );
};